import {
  IPromotionDocumentUploadRepository,
  SubmitPromotionDocumentParams,
  SubmitPromotionDocumentResponse,
} from "@/core/repositories/promotion/IPromotionDocumentUpload.repository";
import { PrivateHttp } from "@/infrastructure/adapters/http";
import { ApiEndpoints } from "@/infrastructure/services/config";
import { ContentType } from "@ir/core/http";

export class PromotionDocumentUploadRepository implements IPromotionDocumentUploadRepository {
  async submitDocument(params: SubmitPromotionDocumentParams): Promise<SubmitPromotionDocumentResponse> {
    const formData = new FormData();
    formData.append("file", params.file);

    formData.append("purchaser_id", String(params.purchaserId));

    if (params.notes) {
      formData.append("notes", params.notes);
    }

    return await new PrivateHttp({
      headers: {
        "Content-Type": ContentType.MULTIPART,
      },
    }).post<SubmitPromotionDocumentResponse>(ApiEndpoints.UPLOAD_PROMOTION_DOCUMENT, formData);
  }
}
